import React, { Component } from 'react';

export class Twitter extends Component {

  render() {

    return (
      <div className="CardBox">
        <div className="CardBoxShadow">
        </div>
        <div className="CardBoxTitleOuter">
          <p className="CardBoxTitle">
          	Coming Soon!
          </p>
					<p className="CardBoxTitle CardBoxSubtitle">

          </p>
        </div>
        <div className="CardBoxContainer">

					<div className="CardBoxBackground NoteBoxBackground" />
					<div className="CardBoxTint" />

          <p className="CardBoxTitle ">
						Soon I&#8217;ll be adding more fun stuff and improving the algorithm! Currently it uses somewhat incomplete, outdated, and vague information. I&#8217;ll be adding stricter calculations to allow it to make better decks and accurately score your decks. For now, don&#8217;t use deckscalibur to score your own decks, or you&#8217;ll be sad. :) <br /><br />

						I&#8217;ll also be adding the ability to analyze the meta and make awesome decks based around it. Whether you want to use cards literally everyone else is using, use direct counters to the meta, or be special and use off meta cards, it&#8217;ll be possible to automate the creation of strong decks! <br /><br />

						Check back to see the improvements, and watch this space for more information on what&#8217;s coming soon!
					</p>

        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Twitter.js